import { render } from "./ReminderView.vue?vue&type=template&id=22cf93e8"
const script = {}

import exportComponent from "C:\\Codeframe\\Dev\\cdn\\pay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__